<template>
  <div class="relative flex flex-col justify-between bg-GRIS_CLARO rounded-3xl shadow-lg max-w-[72%] sm:max-w-[60%] lg:max-w-none p-5 gap-8 card-container">
    <div class="p-3 rounded-full absolute -top-7 left-1/2 -translate-x-1/2 bg-white img-container min-h-[50px] flex items-center justify-center">
      <img
        :src="imagenAutor"
        :alt="data.autor || 'Usuario'"
        class="w-[50px] h-[50px] object-cover rounded-full"
        loading="lazy"
        decoding="async"
        @error="manejarErrorImagen"
      />
    </div>

    <div class="text-center font-semibold gap-10 flex flex-col justify-between h-full mt-10 min-h-[180px]">
      <p>{{ data.texto }}</p>

      <div class="flex justify-between text-start text-sm gap-3">
        <div class="min-w-0">
          <a
            v-if="data.urlAutor"
            :href="data.urlAutor"
            target="_blank"
            rel="noopener noreferrer"
            class="break-words font-semibold"
          >
            {{ data.autor }}
          </a>

          <p v-else class="break-words font-semibold">
            {{ data.autor }}
          </p>

          <p class="text-xs text-gray-500">
            {{ data.tiempoRelativo }}
          </p>

          <p class="text-xs text-gray-500 mt-1">
            {{ data.sucursal?.nombre }}
          </p>
        </div>

        <div class="mt-0">
          <div class="flex items-center gap-3 bg-AMARILLO_RESENAS text-black rounded-md p-2 font-bold text-xs shrink-0">
            <p>{{ data.rating }}</p>
            <img src="/img/newhome/resenas/black-star.webp" class="w-[15px] h-[10px]" alt="Estrella" loading="lazy" decoding="async" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    required: true
  }
})

const imagenPorDefecto = '/img/home/default-user.webp'
const imagenAutor = ref(props.data?.fotoAutor || imagenPorDefecto)

watch(
  () => props.data?.fotoAutor,
  (valor) => {
    imagenAutor.value = valor || imagenPorDefecto
  },
  { immediate: true }
)

function manejarErrorImagen() {
  imagenAutor.value = imagenPorDefecto
}
</script>

<style scoped>
.card-container,
.img-container {
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.2);
}
</style>